var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"w-100 py-18 px-16 py-sm-24 px-sm-32 hp-bg-color-black-20 hp-bg-color-dark-90"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-sm-6"})])])
}]

export { render, staticRenderFns }